export default __webpack_public_path__ + "static/media/uploader-tandem-1.47f668d3.png";